export class FCTBase {
    FCT;
    constructor(FCT) {
        this.FCT = FCT;
    }
}
//# sourceMappingURL=FCTBase.js.map